import { render } from "./SwapThree.vue?vue&type=template&id=1d6ddac2"
import script from "./SwapThree.vue?vue&type=script&lang=js"
export * from "./SwapThree.vue?vue&type=script&lang=js"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__